import * as React from 'react';
import styled from 'styled-components';
import {ColumnProps} from 'components/Column';

export interface RowProps {
  alignItems?: 'flex-start' | 'flex-end';
  children:
    | React.ReactElement<ColumnProps>
    | React.ReactElement<ColumnProps>[];
}

export const Container = styled.div<RowProps>`
  box-sizing: border-box;
  padding: 5px 0;
  align-items: ${({alignItems}) => alignItems || 'flex-start'};
  display: flex;
`;

/**
 * The component wrap columns in row
 * @param {RowProps} props
 * @return {React.ReactElement<RowProps>}
 * @constructor
 */
export default function Row(
    props: RowProps,
): React.ReactElement<RowProps> {
  return (
    <Container {...props}>
      {props.children}
    </Container>
  );
}
